import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

export const useDarkMode = () => {
  const currentUser = useSelector((state: RootState) => state.user.profile);

  useEffect(() => {
    document.body.classList.add('theme-dark');

    return () => {
      // Only remove the class if the user's theme is light mode
      if (currentUser?.theme === 'light') {
        document.body.classList.remove('theme-dark');
      }
    };
  }, [currentUser?.theme]);
};
